<!--
 * @Description: 修改个人信息
 * @Author: 山淑兰
 * @Date: 2019-11-12 15:16:19
 * @LastEditTime: 2020-07-15 18:11:27
 * @LastEditors: 山淑兰
 -->
<template>
  <div id="modifInfo">
    <Loading v-if="show"></Loading>
    <div class="modifInfo_container" v-else>
      <div class="modifInfo-banner">
        <img :src="meetingInfo.MobileBannerImage" alt />
      </div>
      <div class="modifInfo_header">
        <span>修改报名信息</span>
      </div>
      <div id="form">
        <form action class="registrationContent-form">
          <template v-for="(item, index) in userInfo">
            <!-- 输入框 -->
            <div
              class="form-item"
              :key="index"
              v-if="item.formtype === 1 && item.formfix === 0"
            >
              <div class="formItem-title">
                {{ item.formtitle }}
                <span v-show="item.isreq" class="mustfill">*</span>
              </div>
              <input
                type="text"
                name
                :placeholder="item.formdes"
                v-model="item.formval"
                :formfix="item.formfix"
                @blur="commonMeans.on_blur()"
              />
            </div>
            <!-- 姓名 -->
            <div
              class="form-item"
              :key="index"
              v-if="item.formtype === 1 && item.formfix === 2"
            >
              <div class="formItem-title">
                {{ item.formtitle }}
                <span v-show="item.isreq" class="mustfill">*</span>
              </div>
              <input
                type="text"
                name
                :placeholder="item.formdes"
                v-model="item.formval"
                :formfix="item.formfix"
                @blur="commonMeans.on_blur()"
              />
            </div>
            <!-- 年龄 -->
            <div
              class="form-item"
              :key="index"
              v-if="item.formtype === 1 && item.formfix === 6"
            >
              <div class="formItem-title">
                {{ item.formtitle }}
                <span v-show="item.isreq" class="mustfill">*</span>
              </div>
              <input
                type="text"
                name
                :placeholder="item.formdes"
                v-model="item.formval"
                :formfix="item.formfix"
                @change="reNumber(item.formval, $event)"
                @input="signIn"
                @blur="commonMeans.on_blur()"
              />
            </div>
            <!-- 手机号 -->
            <div
              class="form-item"
              :key="index"
              v-if="item.formtype === 1 && item.formfix === 1"
            >
              <div class="formItem-title">
                {{ item.formtitle }}
                <span v-show="item.isreq" class="mustfill">*</span>
              </div>
              <input
                type="text"
                name
                :placeholder="item.formdes"
                v-model="item.formval"
                @change="reNum(item.formval, $event)"
                class="telVal telDisabled"
                @input="signIn"
                disabled
              />
            </div>
            <!-- 邮箱 -->
            <div
              class="form-item"
              :key="index"
              v-if="item.formtype === 1 && item.formfix === 3"
            >
              <div class="formItem-title">
                {{ item.formtitle }}
                <span v-show="item.isreq" class="mustfill">*</span>
              </div>
              <input
                type="text"
                name
                :placeholder="item.formdes"
                v-model="item.formval"
                class="telVal"
                @change="reEmail(item.formval, $event)"
                @input="signIn"
                @blur="commonMeans.on_blur()"
              />
            </div>
            <!-- 身份证 -->
            <div
              class="form-item"
              :key="index"
              v-if="item.formtype === 1 && item.formfix === 4"
            >
              <div class="formItem-title">
                {{ item.formtitle }}
                <span v-show="item.isreq" class="mustfill">*</span>
              </div>
              <input
                type="text"
                name
                :placeholder="item.formdes"
                v-model="item.formval"
                class="telVal"
                @input="signIn"
                @change="reID(item.formval, $event)"
                @blur="commonMeans.on_blur()"
              />
            </div>
            <!-- 单选 -->
            <div
              class="form-item"
              :key="index"
              v-else-if="item.formtype === 2 && item.formfix === 0"
            >
              <div class="formItem-title">
                {{ item.formtitle }}
                <span v-show="item.isreq" class="mustfill">*</span>
              </div>
              <van-radio-group v-model="item.formval">
                <van-radio
                  :name="itemChild.value"
                  icon-size="16"
                  v-for="(itemChild, i) in item.formjsonval"
                  :key="i"
                  >{{ itemChild.value }}</van-radio
                >
              </van-radio-group>
            </div>
            <!-- 性别 -->
            <div
              class="form-item"
              :key="index"
              v-else-if="item.formtype === 2 && item.formfix === 5"
            >
              <div class="formItem-title">
                {{ item.formtitle }}
                <span v-show="item.isreq" class="mustfill">*</span>
              </div>
              <van-radio-group v-model="item.formval">
                <van-radio
                  :name="itemChild.value"
                  icon-size="16"
                  v-for="(itemChild, i) in item.formjsonval"
                  :key="i"
                  >{{ itemChild.value }}</van-radio
                >
              </van-radio-group>
            </div>
            <!-- 多选 -->
            <div class="form-item" :key="index" v-else-if="item.formtype === 3">
              <div class="formItem-title">
                {{ item.formtitle }}
                <span v-show="item.isreq" class="mustfill">*</span>
              </div>
              <van-checkbox-group v-model="item.formval">
                <van-checkbox
                  :name="itemChild.value"
                  shape="square"
                  icon-size="16"
                  v-for="(itemChild, i) in item.formjsonval"
                  :key="i"
                  >{{ itemChild.text }}</van-checkbox
                >
              </van-checkbox-group>
            </div>
            <!-- 下拉框 -->
            <div class="form-item" :key="index" v-else-if="item.formtype === 4">
              <div class="formItem-title">
                {{ item.formtitle }}
                <span v-show="item.isreq" class="mustfill">*</span>
              </div>
              <van-icon
                name="arrow-down"
                color="#64748b"
                class="downIcon"
                size="1.39rem"
              />
              <select v-model="item.formval" @blur="commonMeans.on_blur()">
                <option
                  v-for="(itemChild, i) in item.formjsonval"
                  :key="i"
                  :value="itemChild.value"
                  >{{ itemChild.text }}</option
                >
              </select>
            </div>
            <!-- 多行文本 -->
            <div class="form-item" :key="index" v-if="item.formtype === 5">
              <div class="formItem-title">
                {{ item.formtitle }}
                <span v-show="item.isreq" class="mustfill">*</span>
              </div>
              <textarea class="textarea" v-model="item.formval"></textarea>
            </div>
            <!-- 日期 -->
            <div class="form-item" :key="index" v-if="item.formtype === 9">
              <div class="formItem-title">
                {{ item.formtitle }}
                <span v-show="item.isreq" class="mustfill">*</span>
              </div>
              <van-cell
                is-link
                arrow-direction="down"
                @click="isShowPopup(item)"
                >{{ item.formval }}</van-cell
              >

              <van-popup
                v-model="item.vanShow"
                round
                position="bottom"
                :style="{ height: '50%' }"
                class="timePupop"
              >
                <van-datetime-picker
                  v-model="item.currentDate"
                  type="date"
                  @confirm="(date) => getTime(date, item)"
                  @cancel="isShowPopup(item)"
                  :min-date="minDate"
                />
              </van-popup>
            </div>

            <!-- 搜索下拉框 -->
            <div class="form-item" :key="index" v-if="item.formtype === 8">
              <div class="formItem-title">
                {{ item.formtitle }}
                <span v-show="item.isreq" class="mustfill">*</span>
              </div>
              <van-search
                :placeholder="item.formdes"
                v-model="item.formval"
                @focus="showSearchOption = true"
                @blur="blurs"
                @input="searchOptions(item)"
              />
              <div class="searchOption" v-show="showSearchOption">
                <ul class="searchOption-list" v-if="item.searchVal != false">
                  <li
                    class="searchOption-item"
                    v-for="(itemChild, i) in item.searchVal"
                    :key="i"
                    @click.prevent="getSearchVal(itemChild.value, item)"
                  >
                    {{ itemChild.value }}
                  </li>
                </ul>
                <ul class="searchOption-list" v-else>
                  <li
                    class="searchOption-item"
                    v-for="(itemChild, i) in item.formjsonval"
                    :key="i"
                    @click.prevent="getSearchVal(itemChild.value, item)"
                  >
                    {{ itemChild.value }}
                  </li>
                </ul>
              </div>
            </div>
            <!-- 省市区 -->
            <div class="form-item" :key="index" v-else-if="item.formtype === 6">
              <div class="formItem-title">
                {{ item.formtitle }}
                <span v-show="item.isreq" class="mustfill">*</span>
              </div>
              <van-cell
                is-link
                arrow-direction="down"
                @click="isShowPopup(item)"
                >{{ item.cityVal }}</van-cell
              >
              <van-popup
                v-model="showAddress"
                round
                position="bottom"
                :style="{ height: '50%' }"
                class="addressPupop"
              >
                <van-area
                  :value="item.formval"
                  :area-list="areaList"
                  :columns-placeholder="['请选择', '']"
                  @confirm="(adress) => getAddress(adress, item)"
                  @cancel="isShowPopup(item)"
                  :columns-num="3"
                />
              </van-popup>
            </div>
            <!-- 分割线 -->
            <div class="divider" :key="index" v-else-if="item.formtype === 7">
              <div class="formItem-title">
                {{ item.formtitle }}
                <span v-show="item.isreq" class="mustfill">*</span>
              </div>
              <div class="dividerLine"></div>
            </div>
          </template>
        </form>
      </div>
      <div class="submitBtn nextBtn" @click="submit" v-if="!showSubmitBtn">
        确认并修改
      </div>
      <div class="submitBtn nextBtn" v-else>提交中...</div>
      <Back v-if="backShow"></Back>
    </div>
  </div>
</template>
<script>
import '../../sass/form.scss'
import commonMeans from '../../lib/signUp'
import Area from '../../lib/area.js'
import Loading from '@components/Loading.vue'
import Back from './components/backBtn.vue'

export default {
  name: 'modifInfo',
  components: {
    Loading,
    Back,
  },
  data() {
    return {
      backShow: false,
      Area,
      showT: false,
      showAddress: false,
      commonMeans: {},
      m: '',
      meetingInfo: {}, //会议基本数据
      show: false,
      userInfo: {}, //用户信息
      minDate: new Date(1960,0,1),
      showSearchOption: false,
      areaList: {}, //省市区
      currentDate: new Date(),
      showSubmitBtn: false, //提交中按钮
      searchVal: '', //搜索框的值
      regTel: true,
      regEmail: true,
      regID: true,
      regNumber: true,
      fNavShow: true,
      homeUrl: '',
    }
  },
  async created() {
    this.m = this.$route.query.m
    this.muid = this.$route.query.muid
    this.commonMeans = new commonMeans()
    this.areaList = Area
    await this.getmeetingInfo()
    await this.getUserInfo()
    this.inits()
  },
  methods: {
    async inits() {
      try {
        const params = {m:this.$route.query.m};
        const res = await this.$http.initMeetingInfo(params);
        // sessionStorage.setItem("HomeUrl",res.HomeUrl)
        // sessionStorage.setItem("isshowlogo",res.isshowlogo)
        if (res.HomeUrl == null || res.HomeUrl == '') {
          this.fNavShow = false
        }else{
          this.homeUrl = res.HomeUrl
        }
      } catch (error) {
        console.error(error);
      }
    },
    personCenter() {
      if (this.$route.path == '/signup/modifyInfo') {
        delete this.$route.query.muid
      }
      this.$router.push({
        path: '/signup/signupinfo',
        query: this.$route.query,
      })
    },
    //获取会议基本信息
    async getmeetingInfo() {
      let opt = {
        m: this.m,
      }
      this.meetingInfo = await this.commonMeans.init(opt, this)
      if (this.meetingInfo.Code === 1000) {
        let loginInfo = await this.$http.GetSignMeetingUserByMu(opt)
        console.log('当前登录账户报名信息', loginInfo)

        // this.show = false
      } else {
        this.$notify({
          massage: this.meetingInfo.Msg,
          type: 'danger',
          duration: '3000',
        })
      }
    },
    // 获取
    //获取用户个人信息
    async getUserInfo() {
      this.show = true
      const { m, muid } = this
      let _params = {
        m,
        muid: Number(muid),
      }
      let _Info = await this.$http.GetSignMeetingUser(_params)
      if (_Info.Code === 1000) {
        this.subData(_Info.form_UserVal)
      } else {
        this.$notify({
          message: _Info.Msg,
          type: 'danger',
        })
      }
      this.show = false
    },
    //搜索列表
    getSearchVal(val, item) {
      item.formval = val
      this.showSearchOption = false
    },
    blurs() {
      this.commonMeans.on_blur()
      setTimeout(() => {
        this.showSearchOption = false
      }, 0)
    },
    searchOptions(val) {
      if (val.formval) {
        for (let i = 0; i < val.formjsonval.length; i++) {
          let sd = val.formjsonval[i].value.indexOf(val.formval)
          if (sd != -1) {
            val.searchVal.push(val.formjsonval[i])
          }
        }
      } else {
        val.searchVal = []
      }
    },
    //二级数据
    subData(datas) {
      for (let j = 0; j < datas.length; j++) {
        let k = datas[j]
        let _formtype = datas[j].formtype
        let _formjsonval
        if (_formtype === 3) {
          if (typeof k.formjsonval == 'string') {
            _formjsonval = JSON.parse(k.formjsonval)
          } else {
            _formjsonval = k.formjsonval
          }
          datas[j].formval = []
          datas[j].formjsonval = _formjsonval
        } else if (_formtype === 2 || _formtype === 4 || _formtype === 8) {
          if (typeof k.formjsonval == 'string') {
            _formjsonval = JSON.parse(k.formjsonval)
          } else {
            _formjsonval = k.formjsonval
          }
        }
        datas[j].formjsonval = _formjsonval
        if (k.formval === null) {
          k.formval = ''
        }
        //给日期和省市增加控制显示隐藏属性
        if (k.formtype === 6) {
          console.log('kkk',k)
          k.isShow = false
          k.cityVal = ''
          let cityArr
		  k.cityVal = k.defaultval
          // if( k.defaultval.indexOf("-") != -1 ){
          //   k.cityVal = k.defaultval;
          // }else{
          //   cityArr = k.defaultval.split(",");
          //   console.log('11111',this.areaList)
          //   //console.log(cityArr[0],cityArr[1],cityArr[2])
          //   if( cityArr[0] && cityArr[0] != undefined && cityArr[0] != null){
          //     k.cityVal = this.areaList.province_list[cityArr[0]]
          //   }
          //   if( cityArr[1] && cityArr[1] != undefined && cityArr[1] != null){
          //     k.cityVal = this.areaList.province_list[cityArr[0]] + ','+ this.areaList.city_list[cityArr[1]]
          //   }
          //   if( cityArr[2] && cityArr[2] != undefined && cityArr[2] != null){
          //     if( this.areaList.county_list[cityArr[2]] != undefined ){
          //       k.cityVal = this.areaList.province_list[cityArr[0]] + ','+ this.areaList.city_list[cityArr[1]] + ','+ this.areaList.county_list[cityArr[2]]
          //     }
          //   }
          //}
        }
        if (k.formtype === 8) {
          k.searchVal = []
        }
        if (k.formtype === 9) {
          k.currentDate = new Date(k.defaultval)
          k.isShow = false
          k.vanShow = false
        }
        if (k.defaultval) {
          if (_formtype === 3) {
            k.defaultval = k.defaultval.split(',')
          }
          k.formval = k.defaultval
        }
      }
      this.userInfo = datas
      console.log('当前报名用户信息', this.userInfo)
    },
    // 控制选择日期/地址弹出框的显示和隐藏
    isShowPopup(item) {
      if (item.formtype === 9) {
        item.vanShow = !item.vanShow
      } else if (item.formtype === 6) {
        this.showAddress = !this.showAddress
      }
      setTimeout(() => {
        let set = document.querySelectorAll('button')
        for (let i = 0; i < set.length; i++) {
          set[i].setAttribute('type', 'button')
        }
      }, 0)
    },
    // 选择日期/选择地址 回调事件
    getTime(date, item) {
      let day = date.getDate()
      let month = date.getMonth() + 1
      let year = date.getFullYear()
      item.vanShow = false
      item.formval = year + '-' + month + '-' + day
    },
    // 省市区

    getAddress(address, item) {
      let _address = []
      let _addressVal = []
      console.log(address)
      for (let i = 0; i < address.length; i++) {
        _address.push(address[i].code)
        _addressVal.push(address[i].name)
      }
      this.showAddress = false
      item.formval = _addressVal.join(',')
      item.cityVal = _addressVal.join(',')
	  console.log(item.formval)
    },
    //正则匹配11位手机号
    reNum(val, ev) {
      this.regTel = this.commonMeans.regCheck(val, 'tel', ev, this)
    },
    reEmail(val, ev) {
      this.regEmail = this.commonMeans.regCheck(val, 'Email', ev, this)
    },
    reID(val, ev) {
      this.regID = this.commonMeans.regCheck(val, 'ID', ev, this)
    },
    reNumber(val, ev) {
      this.regNumber = this.commonMeans.regCheck(val, 'number', ev, this)
    },
    // 只能输入数字
    signIn() {
      for (let i = 0; i < this.userInfo.length; i++) {
        let k = this.userInfo[i]
        if (k.formfix === 1) {
          if (k.formval) {
            k.formval = k.formval.replace(/[^\d]/g, '')
          }
        }
      }
    },
    //提交
    submit() {
      let _flag = true
      let data = []
      let _Forms = this.commonMeans.deepCopy(this.userInfo)

      if (!this.regTel) {
        this.$notify({
          message: '请输入正确的手机号！',
          type: 'danger',
        })
        return
      }
      if (!this.regID) {
        this.$notify({
          message: '请输入正确的身份证号！',
          type: 'danger',
        })
        return
      }
      if (!this.regEmail) {
        this.$notify({
          message: '请输入正确的邮箱！',
          type: 'danger',
        })
        return
      }
      // 判断必填项是否为空
      for (let i = 0; i < _Forms.length; i++) {
        const item = this.userInfo[i]
        if (_Forms[i].formtype === 7) {
          //_Forms.pop(_Forms[i])
          delete _Forms[i]
        } else {
          if( item.formfix == 6 ){
            if (!this.regNumber) {
              this.$notify({
                message: '请输入正确的'+ item.formtitle +'！',
                type: 'danger',
              })
              return
            }
          }
          if (item.isreq) {
            if (!item.formval) {
              _flag = false
              this.$notify({
                message: '带*号项不能为空',
                type: 'danger',
              })
              return
            }
          }
          if (_Forms[i].formval === '请选择') {
            _Forms[i].formval = ''
          }
          if (_Forms[i].formtype === 3) {
            _Forms[i].formval = String(_Forms[i].formval)
          }
          data.push({
            value: _Forms[i].formval,
            text: _Forms[i].formtitle,
            formfix: _Forms[i].formfix,
            formid: _Forms[i].formid,
          })
        }
      }
      console.log(data, _flag)

      let UserEntity = []

      UserEntity.push({ DataEntity: data })

      let datas = {
        m: this.$route.query.m,
        muid: this.muid,
        UserEntity,
      }
      console.log('datas', datas)
      if (_flag) {
        this.showSubmitBtn = true
        this.submitform(datas)
      }
    },
    //提交
    async submitform(datas) {
      let res = await this.$http.EditSignMeetingUser(datas)
      console.log(datas)
      this.showSubmitBtn = false
      if (res.Code === 1000) {
        this.$notify({
          message: '提交成功！',
          type: 'success',
        })
      } else {
        this.$notify({
          message: res.Msg,
          type: 'danger',
        })
      }
    },
  },
}
</script>
<style lang="scss">
.van-picker__toolbar{
  height: 2.5rem !important;
}
.van-picker__cancel,
.van-picker__confirm{
  font-size: 1.2rem !important;
  padding: 0 1rem !important;
}
</style>
<style lang="scss" scoped>
#modifInfo {
  position: relative;
  .modifInfo_container {
    padding-bottom: 80px;
  }
  .modifInfo_header {
    font-size: 36px;
    height: 100px;
    line-height: 100px;
    margin: 0 auto;
    text-align: center;
    > span {
      border-bottom: 4px solid #3b82f6;
      padding: 0 10px 10px;
    }
  }
  .modifInfo-banner {
    > img {
      width: 100%;
    }
  }

  .submitBtn {
    width: 30%;
    height: 2.2rem;
    margin: 0 auto;
    border: 0;
    background: #3b82f6;
    color: #fff;
    font-size: 28px;
    text-align: center;
    line-height: 2.2rem;
    border-radius: 8px;
  }
  .telDisabled {
    background: #f1f5f9;
  }
}
.foot-nav{
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 100;
  width: 100%;
  height: 75px;
  padding: 5px 0;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  .fnav{
    width: 100%;
    height: 75px;
    display: flex;
    font-size: 22px;
    li{
      flex: 1;
      text-align: center;
      color: #475569;
      border-right: 1px solid #e2e8f0;
      a{
        color: #475569;
      }
      img{
        display: block;
        width: 40px;
        height: 40px;
        margin: 0 auto;
      }
    }
    li:last-child{
      border-right: none;
    }
  }
}
</style>
